<template>
  <transition name="slide-fade">
    <div class="system-builder__notification" v-bind:style="{ border: '3px solid ' + notificationColor }" v-if="isActive" @click="{$emit('closeNotification')}">
      <div class="system-builder__notification--content">
        <slot name="notification-body"></slot>
        <span class="system-builder__notification--close" @click="closeNotification">
          <i class="fa fa-times-circle-o" aria-hidden="true"></i>
        </span>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'notification',
    props: ['isActive', 'name', 'nColor'],
    data () {
      return {
        notificationName: this.name,
        active: this.isActive,
        notificationColor: this.nColor
      }
    }
  }
</script>



// WEBPACK FOOTER //
// notification.vue?6ecc286f